package com.fireavert.properties.add_new_property_admin.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class CreatePropertyAdminResponse(val success: Boolean, val errorMessage: String)